import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.main.project.add');
import { OnInit, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { IProjectFormData } from '../@types';
import { INSPECTION_TYPES } from '../@constants';
import { projectService } from '../@services';

/** 도면 파일 정보 인터페이스 */
interface IDrawingFile {
    name: string;
    size: string;
    type: string;
}

/** 도면 데이터 인터페이스 */
interface IDrawingData {
    files: IDrawingFile[];
    description: string;
}

/** 사용자 인터페이스 */
interface IUser {
    id: string;
    name: string;
    email: string;
    department: string;
    role: string;
    selected?: boolean;
}

/** 프로젝트 폼 데이터 + 도면 확장 */
interface IProjectFormWithDrawing extends IProjectFormData {
    drawing: IDrawingData;
}

@Component({
    selector: 'wiz-component-main-project-add',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.main.project.add/view.scss */
/* src/app/component.main.project.add/view.scss: no such file or directory */`],
})
export class ComponentMainProjectAddComponent implements OnInit {
    @Output() close = new EventEmitter<any>();

    /** 현재 단계 (1: 기본정보, 2: 도면) */
    public step: number = 1;

    /** 폼 데이터 - 타입 적용 */
    public data: IProjectFormWithDrawing = {
        title: '',
        category: '전체',
        type: '',
        type_etc: '',
        participants: '',
        start_date: '',
        end_date: '',
        client: '',
        drawing: {
            files: [],
            description: ''
        }
    };

    /** 카테고리 목록 */
    public categories: string[] = ['건축', '토목', '전체'];

    /** 점검 종류 목록 - 상수에서 가져옴 */
    public types: string[] = INSPECTION_TYPES;

    /** 실제 파일 객체 저장 */
    public uploadFiles: File[] = [];

    /** 부서 목록 */
    public departments: string[] = ['건축', '토목', '기타'];

    /** 선택된 부서 */
    public selectedDepartment: string = '';

    /** 부서별 사용자 목록 */
    public users: IUser[] = [];

    /** 선택된 참여자 목록 */
    public selectedParticipants: IUser[] = [];

    /** 사용자 검색어 */
    public userSearch: string = '';

    /** 필터링된 사용자 목록 */
    public get filteredUsers(): IUser[] {
        let users = this.users;
        if (this.selectedDepartment === '기타') {
            users = users.filter(u => u.department !== '건축' && u.department !== '토목');
        }
        
        if (!this.userSearch.trim()) {
            return users;
        }
        const keyword = this.userSearch.toLowerCase().trim();
        return users.filter(u => 
            u.name.toLowerCase().includes(keyword) || 
            u.email.toLowerCase().includes(keyword)
        );
    }

    // Project duration in days
    public projectDuration: number = 0;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        // 부모 페이지에서 init/렌더를 담당
    }

    public async selectType(type: string) {
        this.data.type = type;
        if (type !== '기타(직접입력)') {
            this.data.type_etc = '';
        }
        await this.service.render();
    }

    public async selectCategory(category: string) {
        this.data.category = category;
        await this.service.render();
    }

    // Calculate project duration
    public calculateDuration() {
        if (this.data.start_date && this.data.end_date) {
            const start = new Date(this.data.start_date);
            const end = new Date(this.data.end_date);
            const diff = end.getTime() - start.getTime();
            this.projectDuration = Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
            if (this.projectDuration < 0) {
                this.projectDuration = 0;
            }
        } else {
            this.projectDuration = 0;
        }
        this.ref.detectChanges();
    }

    // Get department button class
    public getDepartmentButtonClass(dept: string): string {
        const isSelected = this.selectedDepartment === dept;
        if (isSelected) {
            if (dept === '건축') return 'bg-blue-600 text-white shadow-lg';
            if (dept === '토목') return 'bg-orange-600 text-white shadow-lg';
            if (dept === '기타') return 'bg-emerald-600 text-white shadow-lg';
        }
        return 'bg-slate-900 text-slate-400 hover:bg-slate-700 hover:text-slate-200';
    }

    // Get department card class
    public getDepartmentCardClass(dept: string): string {
        if (dept === '건축') return 'bg-blue-600/10 border-blue-600/30';
        if (dept === '토목') return 'bg-orange-600/10 border-orange-600/30';
        if (dept === '기타') return 'bg-emerald-600/10 border-emerald-600/30';
        return 'bg-slate-700 border-slate-600';
    }

    // Get department badge class
    public getDepartmentBadgeClass(dept: string): string {
        if (dept === '건축') return 'bg-blue-600';
        if (dept === '토목') return 'bg-orange-600';
        if (dept === '기타') return 'bg-emerald-600';
        return 'bg-slate-600';
    }

    // Load users by department
    public async selectDepartment(dept: string) {
        this.selectedDepartment = dept;
        this.userSearch = '';  // 검색어 초기화
        
        const { code, data } = await wiz.call("users", { department: dept });
        if (code === 200) {
            // 이미 선택된 참여자는 selected 표시
            this.users = data.map((u: IUser) => ({
                ...u,
                selected: this.selectedParticipants.some(p => p.id === u.id)
            }));
        } else {
            this.users = [];
        }
        
        this.ref.detectChanges();
    }

    /** 참여자 토글 */
    public toggleParticipant(user: IUser) {
        const index = this.selectedParticipants.findIndex(p => p.id === user.id);
        
        if (index > -1) {
            // 이미 선택됨 -> 제거
            this.selectedParticipants.splice(index, 1);
            user.selected = false;
        } else {
            // 선택 안됨 -> 추가
            this.selectedParticipants.push({ ...user, selected: true });
            user.selected = true;
        }
        
        // participants 문자열 업데이트 (이름만)
        this.data.participants = this.selectedParticipants.map(p => p.name).join(', ');
        this.ref.detectChanges();
    }

    /** 참여자 제거 */
    public removeParticipant(user: IUser) {
        const index = this.selectedParticipants.findIndex(p => p.id === user.id);
        if (index > -1) {
            this.selectedParticipants.splice(index, 1);
        }
        
        // users 목록에서도 selected 해제
        const userInList = this.users.find(u => u.id === user.id);
        if (userInList) {
            userInList.selected = false;
        }
        
        this.data.participants = this.selectedParticipants.map(p => p.name).join(', ');
        this.ref.detectChanges();
    }

    private async alert(message: string, status: string = 'error') {
        await this.service.alert.show({
            title: status === 'success' ? '성공' : '알림',
            message: message,
            status: status,
            action: '확인',
            cancel: false
        });
    }

    /**
     * 다음 단계로 이동
     * - 서비스 레이어를 통한 유효성 검증
     */
    public async next() {
        if (this.step === 1) {
            const validation = projectService.validate(this.data);
            if (!validation.valid) {
                return await this.alert(validation.message!);
            }
            this.step = 2;
        }
        this.ref.detectChanges();
    }

    public async prev() {
        if (this.step > 1) this.step--;
        this.ref.detectChanges();
    }

    public async onFileChange(event: any) {
        const files = event.target.files;
        if (!files || files.length === 0) return;
        
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const identity = file.type.split('/')[0];
            const isPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
            if (identity !== 'image' && !isPDF) {
                await this.alert(`[${file.name}]은 허용되지 않는 파일 형식입니다. 이미지 또는 PDF 파일만 업로드 가능합니다.`);
                continue;
            }

            // 실제 파일 객체 저장
            this.uploadFiles.push(file);

            this.data.drawing.files.push({
                name: file.name,
                size: (file.size / 1024 / 1024).toFixed(2) + 'MB',
                type: file.type
            });
        }
        // input 초기화 (같은 파일 재선택 가능하도록)
        event.target.value = '';
        this.ref.detectChanges();
    }

    public removeFile(index: number) {
        this.data.drawing.files.splice(index, 1);
        this.uploadFiles.splice(index, 1);
        this.ref.detectChanges();
    }

    public async submit() {
        await this.service.loading.show();

        try {
            // 1. 용역 생성
            const { code, data } = await wiz.call("create", {
                title: this.data.title,
                category: this.data.category,
                type: this.data.type,
                type_etc: this.data.type_etc,
                participants: this.data.participants,
                start_date: this.data.start_date,
                end_date: this.data.end_date,
                client: this.data.client,
                description: this.data.drawing.description
            });

            if (code !== 200) {
                await this.service.loading.hide();
                return await this.alert(data || '용역 등록에 실패했습니다.');
            }

            const projectId = data.id;

            // 2. 도면 파일 업로드 (파일이 있는 경우)
            if (this.uploadFiles.length > 0) {
                const fd = new FormData();
                fd.append('project_id', projectId);
                fd.append('description', this.data.drawing.description || '');
                
                for (const file of this.uploadFiles) {
                    fd.append('file[]', file);  // file[] 형태로 전송
                }

                // wiz.url로 URL을 얻고 fetch로 직접 전송
                const uploadUrl = wiz.url("upload");
                const response = await fetch(uploadUrl, {
                    method: 'POST',
                    body: fd
                });
                const uploadResult = await response.json();
                
                if (uploadResult.code !== 200) {
                    console.warn('도면 업로드 실패:', uploadResult.data);
                }
            }

            await this.service.loading.hide();
            await this.alert('새 용역이 등록되었습니다.', 'success');
            this.close.emit(true);

        } catch (e: any) {
            await this.service.loading.hide();
            await this.alert(e.message || '오류가 발생했습니다.');
        }
    }
}

export default ComponentMainProjectAddComponent;